import React, { Component } from "react";
import { Button, Row, Col, Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import storage from "../../../../Storage";
import "./manualBet.css";
import C from "../../../../Constant";
import {
  __,
  wait,
  isValidNumber,
  forceSatoshiFormat,
  User,
  sendNotfication,
  Event,
  playAudio,
} from "../../../../Helper";
import { gameCoin } from "../../../../actions/gameCoin";
import { setWallet } from "../../../../actions/gameWallet";
import { Scale } from "lucide-react";

class ManualBet extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      buttonText: "BET",
      inputDisabled: false,
      buttonProgress: false,
      profit: 10,
      risk: "low",
      chance: 0,
      numbers: [],
      bitError: false,
      outError: false,
      isToggleOn: false,
      lock: false,
      holding: false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 0.0000001
      ),
      isLogged: storage.getKey("logged") !== null ? true : false,
      coin: storage.getKey("coin"),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRisk = this.handleRisk.bind(this);
    this.handleBet = this.handleBet.bind(this);
    this.clearTable = this.clearTable.bind(this);
    this.autoPick = this.autoPick.bind(this);
  }

  componentDidMount() {
    let { engine } = this.state;
    this._isMounted = true;

    //Set Coin from Redux
    this.props.gameCoin();

    engine.on(C.PLAY_SINGLE_KENO, () => this.play());
    engine.on(C.BUSTED_SINGLE_KENO, (data) => this.busted(data));
    engine.on(C.ERROR_SINGLE_KENO, (data) => this.error(data));
  }

  error(data) {
    if (this._isMounted) {
      if (data.message) sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setState({ inputDisabled: false });
    }
  }

  play() {
    if (this._isMounted) {
      this.setState({ inputDisabled: true });
    }
  }

  busted(data) {
    if (this._isMounted) {
      let { numbers } = data;
      this.setState({ inputDisabled: false });

      if (numbers === undefined) return;

      numbers.forEach((number, i) => {
        if (document.getElementById("c_" + number.num) !== null) {
          wait(i * 100).then(() => {
            document
              .getElementById("c_" + number.num)
              .classList.remove("active");
          });

          if (this.state.numbers.includes(number.num)) {
            wait(i * 100).then(() => {
              document
                .getElementById("c_" + number.num)
                .classList.add("bg-danger");
              document
                .getElementById("c_" + number.num)
                .classList.add("text-white");
              playAudio("dice3.mp3");
            });
          } else {
            wait(i * 100).then(() => {
              document
                .getElementById("c_" + number.num)
                .classList.add("bg-success");
              document
                .getElementById("c_" + number.num)
                .classList.add("text-white");
            });
          }
        }
      });

      wait(2000).then(() => {
        this.clearTable();
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleRisk(value) {
    this.setState({ risk: value });
  }

  handleInputChange(event) {
    var target = event.target;
    var value =
      target.type === "checkbox" ? userAutoPlay(target.checked) : target.value;
    var name = target.name;

    if (__.isEmpty(value)) {
      if (name === "amount") this.setState({ amount: value });
      this.setState({ bitError: "" });

      if (name === "risk") this.setState({ outError: "" });
    } else {
      if (name === "amount") this.setState({ bitError: false });

      if (name === "risk") this.setState({ outError: false });
    }

    if (name === "amount") {
      if (value >= 999999999) return;
    }

    if (!isValidNumber(value)) return;

    if (name === "amount") {
      storage.setKey("lam", value);
    }

    this.setState({ [name]: value });
  }

  isCorrectBet(amount) {
    if (amount === 0) return false;

    if (!isValidNumber(amount)) return false;

    if (parseFloat(amount) <= 0) {
      this.setState({ amount: forceSatoshiFormat(0.0000001) });
    } else this.setState({ amount: forceSatoshiFormat(amount) });

    var credit = storage.getKey("credit");

    if (!storage.getKey("playing") === false) {
      if (amount > credit || credit === 0) {
        return false;
      }
    }
    return true;
  }

  placeBet() {
    if (this._isMounted) {
      let { engine, amount, numbers } = this.state;
      wait(100).then(() => {
        engine.init = true;
        engine.coin = this.props.coin;
        engine.numbers = numbers;
        engine.amount = forceSatoshiFormat(amount) * numbers.length;
        engine.play();
      });
    }
  }

  handleBet(e) {
    e.preventDefault();

    let { amount } = this.state;

    // Check User
    if (!this.state.isLogged) {
      return Event.emit("showAuthModal", true);
    }

    if (this.state.numbers.length < 3) {
      return sendNotfication(
        "Please select at least 3 number",
        "info",
        "top-center"
      );
    }

    // Check is Correct Bet
    if (!this.isCorrectBet(this.state.amount)) {
      return sendNotfication(
        "Your Balance is not enough",
        "warning",
        "top-center"
      );
    }

    if (parseFloat(amount) <= 0) {
      this.setState({ amount: forceSatoshiFormat(0.0000001) });
    } else {
      amount = Math.min(
        parseFloat(storage.getKey("credit")),
        parseFloat(amount)
      );
      this.setState({ amount: forceSatoshiFormat(amount) });
    }

    this.setState({ inputDisabled: true });
    this.placeBet();
  }

  selectNum(num) {
    if (this._isMounted) {
      if (!this.state.numbers.includes(num)) {
        if (this.state.numbers.length < 10)
          this.setState((state) => ({ numbers: [num, ...state.numbers] }));
      } else {
        const remove = (num) => {
          return __.without(this.state.numbers, num);
        };
        this.setState(() => ({ numbers: remove(num) }));
      }
    }
  }

  clearTable() {
    if (this._isMounted) {
      this.setState({ numbers: [] });

      for (var i = 0; i < 41; i++) {
        if (document.getElementById("c_" + i) !== null) {
          document.getElementById("c_" + i).classList.remove("bg-success");
          document.getElementById("c_" + i).classList.remove("text-white");
          document.getElementById("c_" + i).classList.remove("bg-danger");
        }
      }
    }
  }

  autoPick() {
    if (this._isMounted) {
      this.clearTable();
      setTimeout(
        function () {
          for (var i = 0; i < 19; i++) {
            let num = getRandomInt(1, 40);
            if (!this.state.numbers.includes(num)) {
              if (this.state.numbers.length !== 10) {
                this.setState((state) => ({
                  numbers: [num, ...state.numbers],
                }));
              }
            }
          }
        }.bind(this),
        getRandomInt(1, 150)
      );
    }
  }

  render() {
    const makeNumber = (num) => {
      let disabled = false;

      let active = false;

      this.state.numbers.forEach((item, i) => {
        if (item === num) {
          active = "active";
        }
      });

      let button = React.createElement(
        "button",
        {
          type: "button",
          id: "c_" + num,
          disabled: disabled,
          className: "btn btn-soft-secondary btn-xl btn-block " + active,
          onClick: () => this.selectNum(num),
          style: { backgroundColor: "#31343C" },
        },
        num
      );
      return React.createElement("div", { className: "keno-numbers" }, button);
    };

    const generateNumber = () => {
      let make = [];
      for (var i = 1; i < 41; i++) {
        make[i] = makeNumber(i);
      }
      return make;
    };

    let { inputDisabled, risk, numbers, bitError, buttonText, amount } =
      this.state;

    return (
      <>
        <form
          className="w-100"
          onSubmit={(e) => {
            e.preventDefault();
            if (this.props.coin === "INR") {
              if (this.state.amount < 20) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else if (this.props.coin === "USDT") {
              if (this.state.amount < 0.5) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else {
              this.handleBet(e);
            }
          }}
        >
          <div className="mine-containers">
            <div className="game-containers">
              {/* header */}
              <div
                className="game-header"
                style={{
                  // width: "100%",
                  // height: "100%",  // Use 100vh for full viewport height
                  padding: "3px 10px",
                  backgroundColor: "#17181b",
                  display: "flex",
                  justifyContent: "center", // Center the container horizontally
                  alignItems: "center", // Center the container vertically
                  boxSizing: "border-box", // Ensure padding doesn't affect the width/height
                  opacity: 0.9,
                  marginTop: "20px",
                  // borderTopLeftRadius: "1rem",  // Top-left corner rounded
                  borderTopRightRadius: "1rem", // Top-right corner rounded
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    gap: "10px",
                    // border:"2px solid red",   // Allow wrapping on smaller screens
                  }}
                >
                  {/* First Circle */}
                  {/* <div
                    className="header-content"
                    style={{
                      borderRadius: "2rem", // Ensure it is circular
                      width: "100%", // Adjust width as a percentage for responsiveness
                      height: "100%", // Fixed height for the div
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center", // Vertically centers content
                      alignItems: "center", // Horizontally centers content
                      textAlign: "center",
                      color: "white",
                      boxSizing: "border-box",
                      flex: "2",
                      padding: "5px",
                      // overflow:"hidden",
                      whiteSpace: "nowrap", // Prevent text from wrapping
                      textOverflow: "ellipsis",
                    }}
                  >
                    <p
                      className="game-header"
                      style={{
                        margin: 0,
                        width: "100%",
                        // border: "2px solid red", // Red border for testing
                        color: "white",
                        borderRadius: "2rem",
                        backgroundColor: "#26272c",
                        padding: "1px", // Add padding to create space around text
                      }}
                    >
                      <span
                        className="game-header"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#43b309",
                          fontFamily: "arial",
                        }}
                      >
                        BankRoll
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          padding: "0px 3px",
                          fontWeight: "bold",
                          color: "gray",
                          fontFamily: "arial",
                        }}
                        className="game-header"
                      >
                        INR
                      </span>
                      <p
                        style={{
                          fontFamily: "arial",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "gray",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          margin: " 0", // Added margin for separation between the elements
                        }}
                        className="game-header"
                      >
                        <img
                          src="/assets/images/inr.png"
                          alt="img"
                          style={{ width: "21px", padding: "0px 1px" }}
                        />
                        <span className="game-header">2842.002</span>
                      </p>
                    </p>
                  </div> */}

                  {/* Second Circle */}
                  {/* <div 
                                        style={{
                                            // border: "2px solid yellow", 
                                            borderRadius: "2rem",  // Ensure it is circular
                                            width: "100%",         // Adjust width as a percentage for responsiveness
                                            height: "100%",      // Fixed height, same as above for uniformity
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center", 
                                            textAlign: "center", 
                                            color: "white", 
                                            fontSize: "15px",
                                            fontWeight:"bold",
                                            padding: "13px",
                                            boxSizing: "border-box",
                                            flex:"3",
                                            backgroundColor: "#26272c",
                                            color:"gray",
                                            overflow:"hidden"
                                        }}
                                        className='fontChange'
                                    >
                            
                                Game results will be displayed here.
                                
                                    </div> */}
                </div>
              </div>
              <div
                style={{
                  padding: "20px",
                  // marginTop: "50px",
                  whiteSpace: "nowrap",
                }}
                className="grid-buttons"
              >
                {generateNumber()}
              </div>
            </div>
            <div
              style={{ borderRight: "2px solid #24262B" }}
              className="bet-containers"
            >
              <Row className="mt-2 allmainbets">
                <div className="d-flex maual-auto">
                  <button
                    style={{
                      width: "170px",
                      borderRadius: "20px",
                      flex: 1,
                      marginRight: "0.5rem",
                      backgroundColor: "#282c34",
                      color: "#fff",
                      border: "none",
                      padding: "0.5rem",
                      fontWeight: "bold",
                      fontFamily: "arial",
                    }}
                    // onClick={() => this.setState({ mode: "manual" })}
                  >
                    Manual
                  </button>
                </div>
                <Row>
                  <Col lg={10} md={10} sm={10} className={"devanshu mt-3"}>
                    <div
                      className={"form-group bet-input mb-2 " + bitError}
                      style={{ padding: "0px 6px" }}
                    >
                      <div
                        style={{
                          color: "gray",
                          fontSize: "15px",
                          padding: "2px",
                          marginLeft: "12px",
                          justifyItems: "center",
                          alignItems: "center",
                          fontFamily: "arial",
                        }}
                        className="game-fonts"
                      >
                        Amount
                      </div>

                      <div
                        style={{
                          borderRadius: "20px",
                          overflow: "hidden", // Ensures child elements respect the parent's border radius
                        }}
                        className="input-group"
                      >
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0", // Remove individual radius
                              border: "none", // Remove default borders
                              fontFamily: "arial",
                            }}
                            className="input-group-text"
                          >
                            Bet
                          </span>
                        </div>
                        <input
                          style={{
                            backgroundColor: "#222328",
                            borderRadius: "0", // Remove individual radius
                            border: "none", // Remove default borders
                          }}
                          disabled={inputDisabled}
                          type="text"
                          className="form-control text-left"
                          id="amount"
                          name="amount"
                          max="900000000"
                          placeholder="Enter Bet Amount"
                          value={amount}
                          autoComplete={"off"}
                          required={true}
                          onKeyUp={this.handleInputChange}
                          onChange={this.handleInputChange}
                        />
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0",
                              border: "none",
                              fontFamily: "arial",
                            }}
                            className="input-group-text"
                          >
                            {this.props.coin}
                          </span>
                        </div>
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0",
                              border: "none",
                            }}
                            className="input-group-text text-lowercase"
                          >
                            x
                          </span>
                        </div>
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0",
                              border: "none",
                            }}
                            className="input-group-text text-lowercase"
                          >
                            {numbers.length}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <span
                        style={{
                          fontFamily: "arial",
                          fontSize: 11,
                          marginLeft: 5,
                        }}
                      >
                        {this.props.coin === "INR"
                          ? "(Minimum Bet - 20 INR)"
                          : "(Minimum Bet - 0.5 USDT)"}
                      </span>
                    </div>
                  </Col>

                  <Col
                    style={{ backgroundColor: "#31343c", borderRadius: "20px" }}
                    lg={9}
                    sm={9}
                    className={"devanshu2 mt-3 "}
                  >
                    <div
                      style={{
                        backgroundColor: "#31343c",
                        borderRadius: "20px",
                      }}
                      className="input-group fw"
                    >
                      <div
                        style={{
                          backgroundColor: "#31343c",
                          borderRadius: "20px",
                        }}
                        className="input-group-append"
                      >
                        <span
                          style={{
                            backgroundColor: "#31343c",
                            color: "gray",
                            fontSize: "15px",
                            padding: "2px",
                            marginLeft: "12px",
                            justifyItems: "center",
                            alignItems: "center",
                            fontFamily: "arial",
                          }}
                          className="input-group-text"
                        >
                          Risk
                        </span>
                      </div>
                      <Dropdown
                        style={{
                          backgroundColor: "#31343c",
                          borderRadius: "20px",
                        }}
                        className={"drop-select btn-block"}
                      >
                        <Dropdown.Toggle
                          split
                          variant=""
                          className={"py-0 mt-0"}
                        >
                          <span
                            style={{ fontFamily: "arial" }}
                            className="text-muted text-center"
                          >
                            <i className={"mdi mdi-chevron-down mr-1"} />
                            {risk}
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          disabled={inputDisabled}
                          className={"dopdown-menu-bottom " + inputDisabled}
                        >
                          <Dropdown.Item
                            style={{ fontFamily: "arial" }}
                            onClick={(e) => this.handleRisk("low")}
                            className={"animated fadeIn"}
                          >
                            Low
                          </Dropdown.Item>
                          <Dropdown.Item
                            style={{ fontFamily: "arial" }}
                            onClick={(e) => this.handleRisk("medium")}
                            className={"animated fadeIn"}
                          >
                            Medium
                          </Dropdown.Item>
                          <Dropdown.Item
                            style={{ fontFamily: "arial" }}
                            onClick={(e) => this.handleRisk("high")}
                            className={"animated fadeIn"}
                          >
                            High
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                  <div
                    className="devanshu col-md-10"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      //   width: "100%",
                    }}
                  >
                    <Col className={"col-md-6 px-2"}>
                      <button
                        style={{
                          borderRadius: "2rem",
                          backgroundColor: "#6B7180",
                          color: "white",
                          width: "100%",
                          //   height: "7vh",
                        }}
                        type={"button"}
                        className={"btn "}
                        disabled={inputDisabled}
                        onClick={this.autoPick}
                      >
                        Auto Pick
                      </button>
                    </Col>
                    <Col className={"col-md-6 px-2"}>
                      <button
                        style={{
                          borderRadius: "2rem",
                          backgroundColor: "#6B7180",
                          color: "white",
                          width: "100%",
                          //   height: "7vh",
                        }}
                        type={"button"}
                        className={"btn"}
                        disabled={inputDisabled}
                        onClick={this.clearTable}
                      >
                        Clear Table
                      </button>
                    </Col>
                  </div>
                  <Col sm={10} lg={10} className={"devanshu m-auto "}>
                    <div className={"form-group rev mb-1"}>
                      <Button
                        style={{
                          // border: "2px solid red",
                          color: "#fff",
                          boxShadow: "rgb(255, 168, 0) 0px -2px 0px inset",

                          // backgroundColor: "rgb(67, 179, 9)",
                          backgroundImage:
                            "linear-gradient(90deg, rgb(255, 215, 0), rgb(255, 140, 0))",
                          borderRadius: "10px",
                        }}
                        variant={"btn btn-sm btn-block mt-2 btn-bet"}
                        disabled={inputDisabled}
                        type="submit"
                      >
                        {buttonText}
                      </Button>
                    </div>

                    <div
                      className="mines-option game-fonts"
                      style={{
                        display: "flex",
                        width: "100%",
                        // display:"none",
                        justifyContent: "space-around",
                        padding: "2px 5px",
                        textAlign: "center",
                        alignItems: "center",
                        justifyItems: "center",
                        margin: "0px 0px",
                        borderTop: "1px solid #222328",
                      }}
                    >
                      {/* Manual */}
                      <div
                        style={{ fontFamily: "arial" }}
                        className={`mines-manual-button`}
                      >
                        Manual
                      </div>

                      {/* Auto */}
                    </div>
                  </Col>
                </Row>
              </Row>
            </div>
          </div>
        </form>
      </>
    );
  }
}

function userAutoPlay(select) {
  User["autoplay"] = select;
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

ManualBet.propTypes = {
  coin: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
});

export default connect(mapStateToProps, { gameCoin, setWallet })(ManualBet);
